import React from 'react';
import Reflux from 'reflux';
import { Popover, Overlay, Row, Col } from 'bootstrap';
import PopoverActions from 'flux/actions/PopoverActions';
import PopoverStore from 'flux/stores/PopoverStore';
import VerticalValueSelector from 'shared/components/form/verticalValueSelector.jsx';
import { Range } from 'immutable';
import moment from 'moment-timezone';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import classNameHelper from 'classnames';
import mobileCheck from 'shared/lib/mobileCheck';

const isMobile = mobileCheck();

/**
 * Generic TimePicker
 */
const TimePickerPopover = React.createClass({
  mixins: [Reflux.connect(PopoverStore, 'popoverVisibility'), PureRenderMixin],

  displayName: 'TimeInput',

  propTypes: {
    className: React.PropTypes.string,
    title: React.PropTypes.string,
    twentyFour: React.PropTypes.bool,
    value: React.PropTypes.number.isRequired, //Used only to initialize internal state
    onChange: React.PropTypes.func.isRequired,
    showResetButton: React.PropTypes.bool,
    updateOnEachChange: React.PropTypes.bool,
    showSeconds: React.PropTypes.bool,
    placement: React.PropTypes.string,
    idSuffix: React.PropTypes.string,
    hideGoalFlag: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
      twentyFour: false,
      showResetButton: false,
    };
  },

  getInitialState() {
    return {
      value: this.props.value,
      valueChanged: false,
    };
  },

  render() {
    return (
      <div
        className="input-time-wrapper"
        id={this.props.idSuffix}
        ref={(el) => {
          this.trigger = el;
        }}
        onClick={() => this._handleDisplayNodeClick()}
      >
        {this.props.displayNode}
        {this._getTimePickerNode()}
      </div>
    );
  },

  _handleDisplayNodeClick() {
    const { id, value } = this.props;

    this.setState({ value });

    PopoverActions.show(id);
  },

  _getTimePickerNode() {
    const {
      // hideGoalFlag,
      id,
      // showResetButton,
      simple,
    } = this.props;

    let { placement } = this.props;

    const { value } = this.state;

    const show = this.state.popoverVisibility.get(id) === true;

    return (
      <Overlay
        placement={placement}
        rootClose
        show={show}
        target={this.trigger}
        onHide={() => {
          /**
           * checks if the time has actually changed
           * if it has allow manual time if not do nothing
           */

          if (this.props.value === this.state.value) {
            this._handleClose(true);
          } else {
            this._handleClose();
          }
        }}
        animation={false}
        autoFocus={false}
      >
        <Popover
          id={'popover-time-input-' + this.props.idSuffix}
          className={classNameHelper('time-picker-popover', {
            'simple-cell': simple,
          })}
          autoFocus={false}
        >
          <div
            className="time-input-popover"
            onKeyDown={(e) => {
              // keyCode 27 - esc
              if (e.keyCode === 27) {
                this._handleClose(true);
              }
            }}
          >
            <TimePicker
              {...this.props}
              value={value}
              hideFooter
              onChange={this._handleChange}
              onClose={this._handleClose}
            />
          </div>
        </Popover>
      </Overlay>
    );
  },

  _handleChange(time, close) {
    this.setState({ value: time, valueChanged: true });
    if (this.props.updateOnEachChange) this.props.onChange(time);

    // this is to make sure state updates before sending the api call
    if (close) setTimeout(this._handleClose, 200);
  },

  _handleClose(escaped) {
    if (!this.state.valueChanged) return PopoverActions.hide(this.props.id);

    /**
     * @param escape Used to fix issue where escape persists value of changed field
     * when re-opening picker
     */
    if (escaped) {
      const { value } = this.props;

      this.setState({ value }, () => {
        return PopoverActions.hide(this.props.id);
      });
    } else {
      const { onChange } = this.props;
      onChange(this.state.value);
    }

    this.setState({ valueChanged: false }, () => {
      PopoverActions.hide(this.props.id);
    });
  },
});

const TimePicker = React.createClass({
  displayName: 'TimePicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    showSeconds: React.PropTypes.bool,
    mobile: React.PropTypes.bool,
    onClose: React.PropTypes.func,
  },

  getInitialState() {
    return {
      emptyHour: false,
      emptyMinute: false,
      emptySecond: false,
      originalValue: this.props.value,
    };
  },

  render() {
    const { twentyFour, showSeconds, mobile, classNames } = this.props;

    const clazzNames = classNameHelper(classNames, 'time-picker', {
      'time-picker-24': twentyFour,
      'time-picker-mobile': isMobile,
    });

    if (mobile) {
      return (
        <div className={clazzNames}>
          <Row>
            <Col xs={24}>
              <div className="csr-time-picker-input-wrapper">
                {this._getHourSelectorNode()}
                {this._getMinuteSelectorNode()}
                {showSeconds ? this._getSecondSelectorNode() : null}
                {twentyFour ? null : this._getMeridiemNode()}
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <span className={clazzNames}>
        <div className="text-center">
          {this._getHourSelectorNode()}
          {this._getMinuteSelectorNode()}
          {showSeconds ? this._getSecondSelectorNode() : null}
          {twentyFour ? null : this._getMeridiemNode()}
        </div>
      </span>
    );
  },

  _getOriginalStartTime(value) {
    const { twentyFour } = this.props;
    const { emptyHour, emptyMinute, emptySecond } = this.state;

    //Hours
    const hours = emptyHour
      ? ''
      : moment.utc(value).format(twentyFour ? 'H' : 'h');
    const hrTxt = hours + 'h';
    //Minutes
    const minutes = emptyMinute ? '' : moment.utc(value).seconds();
    const mnTxt = minutes + 'm';
    //Seconds
    const seconds = emptySecond ? '' : moment.utc(value).seconds();
    const scTxt = seconds + 's';

    const durTxt = hrTxt + ' ' + mnTxt + ' ' + scTxt;

    return durTxt;
  },

  _getMaxHours() {
    const { twentyFour } = this.props;
    const maxHours = twentyFour ? 24 : 12;
    return maxHours;
  },

  _getHourSelectorNode() {
    const { twentyFour, value, mobile, onClose } = this.props;

    const { emptyHour } = this.state;

    let options = Range(0, 24);

    if (!twentyFour) options = Range(1, 13);

    const displayOffset = twentyFour ? value : value + 1;

    const momFormatted = moment
      .utc(displayOffset)
      .format(twentyFour ? 'HH' : 'hh');

    const hourValue = emptyHour
      ? ''
      : moment.utc(value).format(twentyFour ? 'H' : 'h');

    const hourDisplayValue = emptyHour ? '' : momFormatted;

    return (
      <VerticalValueSelector
        textInput
        typePrefix="h"
        initialFocus
        mobile={mobile}
        onChange={this._handleHourChange}
        onBlur={onClose}
        options={options}
        displayValue={hourDisplayValue}
        value={hourValue}
      />
    );
  },

  _getMinuteSelectorNode() {
    const { mobile, onClose } = this.props;
    const { emptyMinute } = this.state;

    const minuteValue = emptyMinute
      ? ''
      : moment.utc(this.props.value).format('mm');
    const minuteDisplayValue = emptyMinute
      ? ''
      : moment.utc(this.props.value).minutes();

    return (
      <VerticalValueSelector
        textInput
        typePrefix="m"
        mobile={mobile}
        onChange={this._handleMinuteChange}
        onBlur={onClose}
        options={Range(0, 60)}
        displayValue={minuteValue}
        value={minuteDisplayValue}
      />
    );
  },

  _getSecondSelectorNode() {
    const { mobile, onTab, twentyFour, onClose } = this.props;
    const { emptySecond } = this.state;

    const secondValue = emptySecond
      ? ''
      : moment.utc(this.props.value).format('ss');
    const secondDisplayValue = emptySecond
      ? ''
      : moment.utc(this.props.value).seconds();

    return (
      <VerticalValueSelector
        textInput
        startTime
        twentyFour
        typePrefix="s"
        mobile={mobile}
        onBlur={onClose}
        onChange={this._handleSecondChange}
        onTab={onTab}
        meridiem={!twentyFour}
        options={Range(0, 60)}
        displayValue={secondValue}
        value={secondDisplayValue}
      />
    );
  },

  _getMeridiemNode() {
    const { value, onClose, onTab } = this.props;

    const meridiem = moment.utc(value).format('a');

    return (
      <div className="start-time-meridiem">
        <input
          type="button"
          className={classNameHelper('meridiem-am', {
            active: meridiem === 'am',
          })}
          onClick={() => this._handleMeridiemClick('am')}
          value="am"
          onKeyDown={(e) => {
            // keyCode 13 - enter
            if (e.keyCode === 13) {
              e.preventDefault();
              this._handleMeridiemClick('am', true);
            }
          }}
        />
        <input
          type="button"
          value="pm"
          className={classNameHelper('meridiem-pm', {
            active: meridiem === 'pm',
          })}
          onClick={() => {
            this._handleMeridiemClick('pm');
          }}
          onBlur={() => {
            onClose();
          }}
          onKeyDown={(e) => {
            // keyCode 9 - tab
            if (e.keyCode === 9) {
              e.preventDefault();
              onClose();
              if (onTab) onTab();
            }
            // keyCode 13 - enter
            if (e.keyCode === 13) {
              e.preventDefault();
              this._handleMeridiemClick('pm', true);
            }
          }}
        />
      </div>
    );
  },

  _handleMeridiemClick(amPm, close) {
    const meridiem = moment.utc(this.props.value).format('a');

    if (meridiem !== amPm) this._handleMeridiemChange(amPm, close);
  },

  _handleHourChange(hour) {
    const { twentyFour, onChange } = this.props;

    const meridiem = moment.utc(this.props.value).format('a');
    const previousValue = moment.utc(this.props.value).hour();
    let isAm = 0;
    let newHour = 0;

    newHour = hour;

    if (hour) {
      this.setState({ emptyHour: false });
    } else {
      this.setState({ emptyHour: true });
    }

    if (!twentyFour) {
      isAm = meridiem === 'am' && !twentyFour ? 0 : 12;

      if (newHour === 12) {
        /**
         * This prevents the clock from moving from 1am to 12pm
         */
        if (previousValue === 1) {
          newHour = 24;
          isAm = 0;
        }
        /**
         * This prevents meridiem change m when inputting 12
         */
        if (previousValue < 12) {
          isAm = 0;
        }
        /**
         * This prevents meridiem change when inputting 12
         */
        if (previousValue === 13) {
          isAm = 0;
        }
        /**
         * value is the same, prevents meridiem change
         */
        if (previousValue === 12) {
          return;
        }
      }

      if (newHour === 11) {
        /**
         * Changes meridiem to am when coming from 12pm
         */
        if (previousValue === 12) {
          isAm = 0;
        }
        /**
         * Changes meridiem to am when comingfrom 12am to 11pm
         */
        if (previousValue === 0) {
          isAm = 12;
        }
      }

      if (newHour === '') {
        /**
         * Prevents meridiem change when backspacing and emptying value
         */
        this.setState({ emptyHour: false });
        if (meridiem === 'am') {
          isAm = 0;
          newHour = 24;
        }
        if (meridiem === 'pm') {
          isAm = 0;
          newHour = 12;
        }
      }

      if (newHour === '12') {
        /**
         * Prevents meridiem change when string value is passed instead of integer
         */
        if (previousValue <= 12) {
          newHour = 0;
        }
        if (previousValue > 12) {
          newHour = 12;
          isAm = 0;
        }
      }
    }

    if (twentyFour && newHour === '') {
      this.setState({ emptyHour: false });
      newHour = 0;
    }

    const val = parseInt(newHour, 10);

    if (isNaN(val)) return;

    const mom = moment.utc(this.props.value).hour(val + isAm);

    onChange(mom.valueOf());
  },

  _handleMinuteChange(minute) {
    const { value, onChange } = this.props;

    let newMinute = minute;

    this.setState({ emptyMinute: false });

    if (minute) {
      newMinute = minute;
    } else {
      newMinute = 0;
    }

    const val = parseInt(newMinute, 10);

    if (val > 59 || val < 0) return;

    const mom = moment.utc(value).minute(val);

    if (isNaN(val)) return;

    onChange(mom.valueOf());
  },

  _handleSecondChange(second) {
    const { value, onChange } = this.props;

    let newSecond = '';

    if (second) {
      this.setState({ emptySecond: false });
      newSecond = second;
    } else {
      this.setState({ emptySecond: true });
      newSecond = 0;
    }

    const val = parseInt(newSecond, 10);

    if (val > 59 || val < 0) return;

    const mom = moment.utc(value).seconds(val);

    if (isNaN(val)) return;

    onChange(mom.valueOf());
  },

  _handleMeridiemChange(amPm, close) {
    const mom = moment.utc(this.props.value);

    const nextHour = amPm === 'am' ? mom.subtract(12, 'h') : mom.add(12, 'h');

    this.props.onChange(nextHour.valueOf(), close);
  },
});

TimePickerPopover.StandAlone = TimePicker;

export { TimePicker as StandAlone };

export default TimePickerPopover;
